import { render, staticRenderFns } from "./Animation20.vue?vue&type=template&id=fc53ffac&scoped=true&"
import script from "./Animation20.vue?vue&type=script&lang=js&"
export * from "./Animation20.vue?vue&type=script&lang=js&"
import style0 from "./Animation20.vue?vue&type=style&index=0&id=fc53ffac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc53ffac",
  null
  
)

export default component.exports